import { Link } from '@chakra-ui/react';

export const getTooltipLabel = (type: 'inProcess' | 'packed' | 'delivered') => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const labels = {
    inProcess:
      'Items at the hub that are or will be available. Could be new, clean, dirty, washed, drying, etc.',
    packed: 'Items sealed in cases and ready for delivery.',
    delivered: (
      <>
        Items at customer sites. To see specific customers, click here and
        &nbsp;
        <Link
          href={`${baseUrl}/unit-tracking?compType=item&status=2`}
          color="blue"
          isExternal>
          export to CSV
        </Link>
      </>
    ),
  };
  return labels[type] || '';
};
